// THIS IS NOT A PATTERN!!! THIS IS HERE BECAUSE WE ARE RELYING ON KNOCKOUT COMPONENTS
// THAT USE THE GLOBAL knockout SCRIPT. THIS SUPPRESSES THOSE WARNINGS.
//@ts-nocheck



//import ko from "knockout";
import { onMount, Show, Signal } from "solid-js";
import STButton, { ButtonType } from "../st-button/st-button";
import { koDataSourceEditor as api }  from 'st-app/api'
import STDataSourceEditor from "../st-data-source-editor/st-data-source-editor";
import './data-source-editor.css'

interface DataSourceEditorProps {
    showActions: boolean
    queryType: Signal<string>
    query: Signal<string>
}

export default function DataSourceEditor(props: DataSourceEditorProps) {
    if (!window.ko) return (
        <STDataSourceEditor query={props.query} type={props.queryType} />
    )

    let analyticsComponent: HTMLDivElement

    const [_query, setQuery] = props.query
    const [_queryType, setQueryType] = props.queryType

    const reportGu = ko.observable()
    const report = ko.observable(null)
    const query = ko.observable('')
    const queryType = ko.observable('')
    const editVM = ko.observable()

    query.subscribe(setQuery)
    queryType.subscribe(setQueryType)

    onMount(async () => {
        // Don't feel great about this, but we need to wait until the txp component loader has initialized before trying to render.
        await new Promise<void>((resolve) => {
            const interval = setInterval(() => {
                if (window.COMPONENT_LOADER) {
                    clearTimeout(interval)
                    resolve()
                }
            }, 10)
        })

        ko.bindingHandlers.bsChecked = {
            init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
                var value = valueAccessor();
                var newValueAccessor = function () {
                    return {
                        change: function () {
                            value(element.value);
                        }
                    }
                };
                ko.bindingHandlers.event.init(element, newValueAccessor,
                    allBindingsAccessor, viewModel, bindingContext);
            },
            update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
                if ($(element).val() == ko.unwrap(valueAccessor())) {
                    setTimeout(function () {
                        $(element).closest('.btn').button('toggle');
                    }, 1);
                }
            }
        };


        //@ts-ignore
        require(['analytics.reportsetup.edit'], (txpEditVM: any) => {
            const vm = new txpEditVM({}, null, () => ({ subscribe: () => { } }))
            vm.tabsConfig.component = {
                selectedIndex: ko.observable(),
            }

            vm.config.showDatabaseConnectionDropDown = false;
            vm.config.showQueryEditSaveButton = false;
            vm.config.fromReportBrowser = true;

            ko.when(() => !vm.isLoading(), async () => {
                if (reportGu()) {
                    const data = await api.GetDataSourceInfo(reportGu());
                    vm.report.queryType(data.queryType);

                    switch (data.queryType) {
                        case 'ST Query':
                            vm.report.sql('')
                            vm.report.stQueryText(data.query);
                            break;
                        case 'SQL Query':
                            vm.report.stQueryText('');
                            vm.report.sql(data.query);
                            break;
                    }
                } else {
                    report(vm.report);
                    vm.report.sql.subscribe((v: string) => {
                        if (vm.report.queryType() === 'SQL Query') {
                            query(v);
                        }
                    })

                    vm.report.stQueryText.subscribe((v: string) => {
                        if (vm.report.queryType() === 'ST Query') {
                            query(v);
                        }
                    })

                    vm.report.queryType.subscribe((v: string) => {
                        queryType(v);

                        switch (v) {
                            case 'ST Query':
                                query(vm.report.stQueryText());
                                break;
                            case 'SQL Query':
                                query(vm.report.sql());
                                break;
                        }
                    });
                }
            });

            editVM(vm)

            ko.applyBindings({
                reportGu,
                report,
                query,
                queryType,
                editVM,
            }, analyticsComponent)
        })
    })

    const save = async () => {
        const postData = editVM().getPostData()
        const report = await api.Save(reportGu(), postData.queryType, postData.query, postData.columns, postData.parameters)
    }

    return (
        <div class="data-source-editor">
            <Show when={props.showActions}>
                <div class="edit-actions">
                    <STButton type="primary" onClick={save}>Save</STButton>
                </div>
            </Show>

            <div ref={analyticsComponent!} data-bind="component: { name: 'analytics.reportsetup.queries', params: { config: editVM } }"></div>
        </div>
    )
}